import { render, staticRenderFns } from "./SetNotarPriceType.vue?vue&type=template&id=167c6c8f"
import script from "./SetNotarPriceType.vue?vue&type=script&lang=js"
export * from "./SetNotarPriceType.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports